import r from"./_cloneArrayBuffer.js";function e(e,f){var t=f?r(e.buffer):e.buffer;return new e.constructor(t,e.byteOffset,e.length)}export{e as default};
//# sourceMappingURL=_cloneTypedArray.js.map
